import React from "react";
import OAuthCallbackShell from "./OAuthCallbackShell";
import { postRequest } from "../../services/api/apiService";

const buildPayload = (params) => ({
  code:  params.get("code")  || "",
  state: params.get("state") || "",
});

// A prior connection failure (e.g. the missing rw_ads scope) can leave a
// stale error banner in Campaign Manager: it's held in an in-memory status
// map cleared only on the next successful sync, and the frontend only
// re-fetches that status when the user re-selects the platform tab. Trigger
// a sync immediately on reconnect so the banner clears without waiting for
// the next 5-min cron cycle or a manual tab switch.
const triggerSync = () => postRequest("/api/sync/trigger").catch(() => {});

const LinkedInAdsCallback = () => (
  <OAuthCallbackShell
    platform="LinkedIn Ads"
    endpoint="/api/ads-auth/linkedin/callback"
    buildPayload={buildPayload}
    onSuccess={triggerSync}
  />
);

export default LinkedInAdsCallback;
